import axios from 'axios';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { InitState, LocalStorageText } from '../contants/common.js';

export const baseURL = 'https://qafqtior.digiin.vn/api';
let headers = {};
// headers['content-type'] = 'application/json';
// axios instance
const instance = axios.create({
  baseURL,
  headers,
});

// Thêm log thời gian request
instance.interceptors.request.use(async (config) => {
  // Thêm timestamp bắt đầu request
  config.metadata = { startTime: new Date() };
  
  const isTokenHave = localStorage.token && localStorage.token !== InitState;
  if (isTokenHave && !config["unuse-authorization"]) {
    config.headers['Authorization'] = 'Bearer ' + localStorage.token;
  }
  return config;
});

// Thêm log thời gian response
instance.interceptors.response.use(
  (response) => {
    const endTime = new Date();
    const startTime = response.config.metadata.startTime;
    const duration = endTime - startTime;
    
    // Log thời gian nếu request lớn hơn 1MB hoặc thời gian xử lý lâu hơn 3 giây
    if (response.headers['content-length'] > 1000000 || duration > 3000) {
      console.warn(`API Request to ${response.config.url} took ${duration}ms, size: ${response.headers['content-length'] || 'unknown'} bytes`);
    }
    
    return Promise.resolve(response?.data);
  },
  (error) => {
    if (error.response) {
      const endTime = new Date();
      const startTime = error.config.metadata.startTime;
      const duration = endTime - startTime;
      
      console.error(`API Error to ${error.config.url} took ${duration}ms:`, error.message);
      
      const errorHttpCode = [401, 403];
      const status = error?.response?.status || 500;
      if (errorHttpCode.includes(status)) {
        localStorage.removeItem(LocalStorageText.Token);
        localStorage.removeItem('user'); // remove info user
        history.push('/login');
        return;
      }
      return Promise.reject({...error?.response?.data, status});
    }
    throw error;
  }
);

const AxiosInterceptor = ({ children }) => {
  const history = useHistory();
  
  return children;
};

export default instance;
export { AxiosInterceptor };
